
import React, { useState, useEffect, useMemo } from "react";
import { Nav, Form, Tab, Modal } from "react-bootstrap";
import ComplianceDashboardAll from "../../Components/ComplianceDashboardComp/ComplianceDashboardAll";
import ComplianceDashboardApproved from "../../Components/ComplianceDashboardComp/CompliancedashboardApproved";
import ComplianceDashboardRejected from "../../Components/ComplianceDashboardComp/ComplianceDashboardRejected";
import ComplianceDashboardActive from "../../Components/ComplianceDashboardComp/ComplianceDashboardActive";
import ComplianceDashboardUnderReview from "../../Components/ComplianceDashboardComp/ComplianceDashboardUnderReview";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import Header from "../../Components/Header";
import { Constants } from "../../CommonMethhods/Constants";
import { Baseurl, Frenchisee } from "../../Configuration/Frenchisee_URL";
import { useDebounce } from "../../Components/useDebounce";
import { decryptData } from "../../CommonMethhods/CommonMethods";
import { toast } from "react-toastify";
import Loader from "../../Components/Common/Loader";
import axiosInstance, { axiosFormDataInstance } from "../../CommonMethhods/axiosInstance";


function ComplianceDashboard() {
    const storeToken = localStorage.getItem("ssoToken");
    const [linecard, setLinecard] = useState("block-active col-division-5");
    const [loader, setLoader] = useState(false);
    const [tabStatus, setTabStatus] = useState("all");
    const [page, setPage] = useState(1);
    const [scrollLoader, setScrollLoader] = useState(false);
    const [frenchiseeOnboardingData, setFrenchiseeOnboardingData] = useState([])
    const [totalCount, setTotalCount] = useState();
    const [dayWiseDate, setDayWiseDate] = useState("this-month")
    const [searchVal, setSearchVal] = useState('')
    const [customDate, setCustomDate] = useState(false)
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [name, setName] = useState("");

    if(storeToken == null){
        window.location.replace("/");
      }

    if(storeToken == null){
        window.location.replace("/")
      }

    localStorage.setItem("statusOfClient", tabStatus);
    const debouncedValue = useDebounce(name, 1000);
    useEffect(() => {
        if (debouncedValue) {
            handleSearchName(debouncedValue);
        }
    }, [debouncedValue]);

    const handleSearchName = () => {
        if (debouncedValue) {
            onboardingDataBackOffice(page, tabStatus, 10, dayWiseDate, debouncedValue);
            setLoader(false);
        }
        setScrollLoader(false);
    };

    useEffect(() => {
        if (localStorage.getItem("activeTab")) {
            setTabStatus(localStorage.getItem("activeTab"));
        } else {
            onboardingDataBackOffice(page, tabStatus, 10, dayWiseDate, name == "")
        }
        return () => {
            localStorage.removeItem("activeTab");
        };
    }, [page, tabStatus, dayWiseDate, name == ""]);


    if (storeToken == null) {
        window.location.replace("/");
    }
    function handleGridView(e) {
        if (linecard === "") setLinecard("block-active col-division-5");
    }

    function handleListView() {
        if (linecard === "block-active col-division-5") setLinecard("");
    }


    const onboardingDataBackOffice = async (pageNo = 1, tab, sizePage = 10, dayWise) => {
        setLoader(true);
        try {
            const getOnboardingDetails = await axiosInstance.get(
                `${Frenchisee.GET_FRENCHISEE_DETAILS}?status=${tab}&page=${pageNo}&limit=${sizePage}&range=${dayWise}&to=${toDate}&from=${fromDate}&search=${name}`,
            );
            const res = decryptData(getOnboardingDetails?.data);
            let respStore = JSON.parse(res)

            if (respStore?.status === 0) {
                setTotalCount(respStore.data.info.count)
                if (pageNo > 1) {
                    setFrenchiseeOnboardingData((prev) => {
                        return [...prev, ...respStore?.data.info.franchisees];
                    });
                } else {
                    setFrenchiseeOnboardingData(respStore?.data.info.franchisees);
                }
            }
            else {
                setFrenchiseeOnboardingData([])
            }
        } catch (error) {
        }
        finally {
            setLoader(false);
            setScrollLoader(false);
        }
    };

    // for pagination start

    const handleScroll = async (e) => {
        const a = e.target;
        if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
            if (!(totalCount <= 10 * page)) {
                setPage((prev) => prev + 1);
                setScrollLoader(true);
            }
        }
    };

    // for pagination end


    function handleTabStatus(status) {
        setTabStatus(status);
        setPage(1);
        setName("")
        localStorage.setItem("statusOfClient", tabStatus);

    }


    const handleOnChange = (e) => {
        setPage(1);
        // setTabStatus("all");
        if (e.target.value != "Custom Range") {
            setDayWiseDate(e.target.value)
            setName("")
            // onboardingDataBackOffice(page, tabStatus, 10, e.target.value);
        }
        else {
            setDayWiseDate("");
            setCustomDate(true)
            setName("")
        }
    };
    const serachBar = useMemo(() => {
        if (searchVal === "") {
            return frenchiseeOnboardingData;
        } else if (frenchiseeOnboardingData && frenchiseeOnboardingData?.length > 0) {
            return frenchiseeOnboardingData?.filter((item) =>
                Object.values(item).some((val) =>
                    String(val)?.toLowerCase()?.includes(searchVal?.toLowerCase())
                )
            );
        }
    }, [searchVal, frenchiseeOnboardingData]);

    const handleChange = (e) => {
        if (e.key === "Enter" || e.key === "Backspace") {
            setSearchVal(e.target.value);
        } else if (e.type === "click") {
            const doc = document.getElementById("trad-map")?.value;
            setSearchVal(doc);
        }
    };
    function SubmitButton() {
        if (fromDate && toDate) {
            return <button type="button" className="rej-btn " onClick={() => { onboardingDataBackOffice(page, tabStatus, 10, dayWiseDate); setCustomDate(false); setToDate(""); setFromDate("") }}>Button</button>
        } else {
            return <button type="button" className="rej-btn" disabled>Button</button>
        };
    };

    const downloadFile = async(url)=>{
        const response = await axiosFormDataInstance.get(url)
        const headers = response.headers
        if(headers["content-type"] !== "text/csv"){
          toast.error("No Data Found")
          return
        }
        const binary = [];
        binary.push(response.data)
        const href = window.URL.createObjectURL(new Blob(binary, {type: "text/csv"}))
        const link = document.createElement("a")
        link.href = href
        link.setAttribute("download", "lead.csv")
        document.body.appendChild(link)
        link.click();
    
        document.body.removeChild(link)
        window.URL.revokeObjectURL(href);
      }

    return (
        <>
            <Header portal={"TELECALLER"} />
            <SingleSignOnSideBar />
            <main id="main-content" className="onboarding-pending">
                <div className="tab-content" id="myTabContent">
                    <Tab.Container id="left-tabs-example" activeKey={tabStatus}>
                        {/* page tabs */}
                        <div>
                            <Nav variant="nav tabs page-tabs">
                                <li
                                    className="nav-item"
                                    onClick={() => handleTabStatus("all")}
                                >
                                    <Nav.Link eventKey="all">All</Nav.Link>
                                </li>
                                <li
                                    className="nav-item"
                                    onClick={() => handleTabStatus("comp-approved")}
                                >
                                    <Nav.Link eventKey="comp-approved">Approved</Nav.Link>
                                </li>
                                <li
                                    className="nav-item"
                                    onClick={() => handleTabStatus("comp-rejected")}
                                >
                                    <Nav.Link eventKey="comp-rejected">
                                        Rejected
                                    </Nav.Link>
                                </li>

                                <li
                                    className="nav-item"
                                    onClick={() => handleTabStatus("comp-active")}
                                >
                                    <Nav.Link eventKey="comp-active">Active</Nav.Link>
                                </li>
                                <li
                                    className="nav-item"
                                    onClick={() => handleTabStatus("active")}
                                >
                                    <Nav.Link eventKey="active">Under Review</Nav.Link>
                                </li>
                            </Nav>
                        </div>

                        <div className="onboarding-secondary-tab-list">
                            <div className="search-box">
                                <div className="form-group">
                                    <div className="for-position oms-search">
                                        <input
                                            type="text"
                                            className="input-st"
                                            placeholder="Search here..."
                                            autoComplete="off"
                                            id="trad-map"
                                            value={name}
                                            onChange={(e) => {
                                                setName(e.target.value)
                                                setPage(1)
                                            }
                                            }
                                            onInput={(e) => {
                                                const start = e.target.selectionStart;
                                                const end = e.target.selectionEnd;

                                                let input = e.target.value.toUpperCase();
                                                input = input.replace(/[^a-zA-Z0-9 ]/g, "");
                                                        input = input.replace(/\s{2,}/g, " "); 
                                                        input = input.replace(/^\s+/, ""); 

                                                if (input.length > 100) input = input.slice(0, 100);
                                                e.target.value = input;
                                                e.target.setSelectionRange(start, end);
                                                }}
                                        />
                                        {/* <span
                                            className="icon-search-bar"
                                            onClick={(e) => handleChange(e)}
                                        /> */}
                                    </div>
                                </div>
                            </div>
                            <div className="menu-rank-wrapper partner-menu">
                                <div 
                                onClick={()=>downloadFile(`${Baseurl}/franchisees/csv?status=${tabStatus}&range=${dayWiseDate}`)}
                                    className={
                                        frenchiseeOnboardingData && frenchiseeOnboardingData.length > 0
                                            ? ""
                                            : "disabled-link"
                                    }>
                                    <span className="icon-download"></span>
                                </div>
                                <div className="card-right card-tabs">
                                    <div className="dropdown-filter">
                                        <Form.Select
                                            size="lg"
                                            aria-label="Default select example"
                                            onChange={(e) => {
                                                handleOnChange(e)
                                            }}
                                        >
                                            <option value="this-month">This Month</option>
                                            <option value="today">Today</option>
                                            <option value="yesterday">Yesterday</option>
                                            <option value="this-week">This Week</option>
                                            <option value="last-week">Last Week</option>
                                            <option value="last-month">Last Month</option>
                                            <option value="till-date">Till Date</option>
                                            <option value="Custom Range">Custom Range</option>
                                        </Form.Select>
                                    </div>
                                </div>
                                <div className="menu-wrapper">
                                    <span
                                        className="icon-block-menu"
                                        onClick={handleGridView}
                                    ></span>
                                    <span
                                        className="icon-horizontal-menu"
                                        onClick={handleListView}
                                    ></span>
                                </div>

                            </div>
                        </div>
                        <div className="for-grid-section">
                            {loader ? (
                                <div className="loader-alignment">
                                    <Loader />
                                </div>
                            ) : (
                                <Tab.Content>
                                    <ComplianceDashboardAll
                                        frenchiseeOnboardingData={frenchiseeOnboardingData}
                                        linecard={linecard}
                                        handleScroll={handleScroll}
                                        scrollLoader={scrollLoader}


                                    />
                                    <ComplianceDashboardApproved
                                        frenchiseeOnboardingData={frenchiseeOnboardingData}
                                        linecard={linecard} handleScroll={handleScroll}
                                        scrollLoader={scrollLoader}


                                    />
                                    <ComplianceDashboardRejected
                                        frenchiseeOnboardingData={frenchiseeOnboardingData}
                                        linecard={linecard}
                                        handleScroll={handleScroll}
                                        scrollLoader={scrollLoader}


                                    />
                                    <ComplianceDashboardActive
                                        frenchiseeOnboardingData={frenchiseeOnboardingData}
                                        linecard={linecard}
                                        handleScroll={handleScroll}
                                        scrollLoader={scrollLoader}


                                    />

                                    <ComplianceDashboardUnderReview
                                        frenchiseeOnboardingData={frenchiseeOnboardingData}
                                        linecard={linecard}
                                        handleScroll={handleScroll}
                                        scrollLoader={scrollLoader}

                                    />
                                </Tab.Content>

                            )}
                        </div>
                    </Tab.Container>
                </div>
                {customDate && customDate ? <Modal
                    show={customDate}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className="setting-model partner-modal-rejection"
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title-vcenter">
                            <h2 className="model-title">
                                Custom Date
                            </h2>
                        </Modal.Title>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close" >
                            <span className="icon-close" onClick={() => setCustomDate(false)}></span>
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="custom-modal-wrapper row">

                            <div className="col-md-6 ">
                                <label className="form-label">{Constants.From_Date}</label>
                                <input
                                    type="date"
                                    placeholder="DD/MM/YYYY"
                                    className="form-control"
                                    onChange={e => setFromDate(e.target.value)}

                                />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">{Constants.To_Date}</label>
                                <input
                                    type="date"
                                    placeholder="DD/MM/YYYY"
                                    className="form-control"
                                    onChange={e => setToDate(e.target.value)}


                                />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <SubmitButton />
                    </Modal.Footer>
                </Modal> : null

                }



            </main>




        </>
    );
}

export default ComplianceDashboard;


